import { Component, inject } from '@angular/core'
import { CartService } from '@account/Services/CartService'
import Address from '@account/Address'
import HttpError from '@ui/HttpError'
import { PageComponent } from '@account/Components/ui/Page/Page.Component'
import { CheckoutItemsComponent } from '@account/Components/Checkout/Items/CheckoutItems.Component'
import { NgStyle } from '@angular/common'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'
import { CheckoutAddressComponent } from '@account/Components/Checkout/Address/CheckoutAddress.Component'
import { CheckoutPaymentFormComponent } from '@account/Components/Checkout/Payment/CheckoutPaymentForm.Component'

@Component({
	selector: 'cart-checkout',
	templateUrl: './Checkout.Component.html',
	styleUrls: ['./Checkout.Component.css'],
	imports: [
		PageComponent,
		CheckoutItemsComponent,
		NgStyle,
		RaisedButtonComponent,
		CheckoutAddressComponent,
		CheckoutPaymentFormComponent,
	],
})
export class CheckoutComponent {
	public step = 1

	public cartService: CartService

	constructor() {
		this.cartService = inject(CartService)
	}

	public assignBillingAddress = async (event: Address) => {
		try {
			await this.cartService.associateBillingAddress(event)

			this.step = 2
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}

	public goToStep = (step: number) => (this.step = step)
}
